// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import type { MedplumClientOptions } from '@medplum/core';

/** Request a durable browser session so the SDK can refresh one-hour access tokens. */
export const PROVIDER_AUTH_SCOPE = 'openid profile offline_access';

/** Refresh ten minutes before expiry to avoid requests racing the access-token deadline. */
export const PROVIDER_AUTH_REFRESH_GRACE_PERIOD = 10 * 60 * 1000;

export function getProviderMedplumOptions(): Pick<MedplumClientOptions, 'refreshGracePeriod'> {
  return {
    refreshGracePeriod: PROVIDER_AUTH_REFRESH_GRACE_PERIOD,
  };
}
